export const spacedRepetitionTranslations = {
  fr: {
    title: "Révision espacée",
    titleMobile: "Révision",
    close: "Fermer",
    cardProgress: "Carte {{current}} sur {{total}}",
    question: {
      title: "Question"
    },
    answer: {
      title: "Réponse"
    },
    rateCard: "Évaluez la difficulté de cette carte :",
    actions: {
      veryDifficult: "Très difficile",
      difficult: "Difficile", 
      good: "Bon",
      easy: "Facile",
      veryEasy: "Très facile"
    },
    showAnswer: "Voir la réponse",
    skip: "Passer",
    stats: {
      correct: "Correct",
      incorrect: "Incorrect",
      avgResponse: "Temps moyen",
      avgConfidence: "Confiance moy."
    },
    mastery: {
      new: "Nouveau",
      beginner: "Débutant",
      inProgress: "En cours",
      mastered: "Maîtrisé"
    },
    session: {
      completed: "Session terminée !",
      completedDescription: "Vous avez étudié {{count}} cartes en {{time}} minutes avec {{accuracy}}% de réussite."
    },
    empty: {
      title: "Aucune carte à réviser",
      description: "Toutes vos cartes sont à jour ! Revenez plus tard pour de nouvelles révisions."
    },
    errors: {
      loadError: "Impossible de charger les cartes pour révision",
      saveError: "Erreur lors de la sauvegarde",
      retryError: "Erreur après {{attempts}} tentatives : {{error}}",
      continueError: "Erreur : {{error}}"
    },
    feedback: {
      correct: "Bonne réponse !",
      incorrect: "Mauvaise réponse",
      nextReview: "Prochaine révision : {{date}}",
      updateApplied: "Mise à jour appliquée"
    },
    cardDeleted: "Carte supprimée avec succès"
  },
  en: {
    title: "Spaced Repetition",
    titleMobile: "Review",
    close: "Close",
    cardProgress: "Card {{current}} of {{total}}",
    question: {
      title: "Question"
    },
    answer: {
      title: "Answer"
    },
    rateCard: "Rate the difficulty of this card:",
    actions: {
      veryDifficult: "Very difficult",
      difficult: "Difficult", 
      good: "Good",
      easy: "Easy",
      veryEasy: "Very easy"
    },
    showAnswer: "Show answer",
    skip: "Skip",
    stats: {
      correct: "Correct",
      incorrect: "Incorrect",
      avgResponse: "Avg time",
      avgConfidence: "Avg confidence"
    },
    mastery: {
      new: "New",
      beginner: "Beginner",
      inProgress: "In progress",
      mastered: "Mastered"
    },
    session: {
      completed: "Session completed!",
      completedDescription: "You studied {{count}} cards in {{time}} minutes with {{accuracy}}% success rate."
    },
    empty: {
      title: "No cards to review",
      description: "All your cards are up to date! Come back later for new reviews."
    },
    errors: {
      loadError: "Unable to load cards for review",
      saveError: "Error saving",
      retryError: "Error after {{attempts}} attempts: {{error}}",
      continueError: "Error: {{error}}"
    },
    feedback: {
      correct: "Correct answer!",
      incorrect: "Wrong answer",
      nextReview: "Next review: {{date}}",
      updateApplied: "Update applied"
    },
    cardDeleted: "Card deleted successfully"
  },
  es: {
    title: "Repetición espaciada",
    titleMobile: "Repaso",
    close: "Cerrar",
    cardProgress: "Tarjeta {{current}} de {{total}}",
    question: {
      title: "Pregunta"
    },
    answer: {
      title: "Respuesta"
    },
    rateCard: "Califica la dificultad de esta tarjeta:",
    actions: {
      veryDifficult: "Muy difícil",
      difficult: "Difícil", 
      good: "Bueno",
      easy: "Fácil",
      veryEasy: "Muy fácil"
    },
    showAnswer: "Mostrar respuesta",
    skip: "Saltar",
    stats: {
      correct: "Correcto",
      incorrect: "Incorrecto",
      avgResponse: "Tiempo promedio",
      avgConfidence: "Confianza prom."
    },
    mastery: {
      new: "Nuevo",
      beginner: "Principiante",
      inProgress: "En progreso",
      mastered: "Dominado"
    },
    session: {
      completed: "¡Sesión completada!",
      completedDescription: "Estudiaste {{count}} tarjetas en {{time}} minutos con {{accuracy}}% de éxito."
    },
    empty: {
      title: "No hay tarjetas para repasar",
      description: "¡Todas tus tarjetas están al día! Vuelve más tarde para nuevos repasos."
    },
    errors: {
      loadError: "No se pueden cargar las tarjetas para repaso",
      saveError: "Error al guardar",
      retryError: "Error después de {{attempts}} intentos: {{error}}",
      continueError: "Error: {{error}}"
    },
    feedback: {
      correct: "¡Respuesta correcta!",
      incorrect: "Respuesta incorrecta",
      nextReview: "Próximo repaso: {{date}}",
      updateApplied: "Actualización aplicada"
    },
    cardDeleted: "Tarjeta eliminada con éxito"
  }
};